import Vue from 'vue';

Vue.component('organisers-component', {
    props: ['organisers'],

    data() {
        return {
            search: '',
        };
    },

    watch: {

    },

    mounted() {
    },

    computed: {
        filteredList() {
            return this.organisers.filter(post => {
                return post.title.toLowerCase().includes(this.search.toLowerCase())
            })
        }
    },

    methods: {

    },

    beforeDestroy() {
    },
});
